import { convertToPDFTronParams } from '@app/application/reconciliation_proposal/utils'
import {
  ANNOTATION_BORDER_COLOR_RGB,
  ANNOTATION_FILL_COLOR_RGB,
  ANNOTATION_SELECTED_BORDER_COLOR_RGB,
  ANNOTATION_SELECTED_FILL_COLOR_RGB,
} from '@app/application/reconciliation_proposal/constants'

export default class AnnotationService {
  constructor(annotationManager, documentViewer) {
    this.instance = annotationManager.instance
    this.annotationManager = annotationManager
    this.documentViewer = documentViewer
    this.annotations = {}

    this.enableRedaction = this.enableRedaction.bind(this)
  }

  buildAnnotation(coordinates, page) {
    const parsedCoords = JSON.parse(coordinates)
    if (parsedCoords.length < 4) {
      return
    }

    const coords = parsedCoords.map((coord) => parseFloat(coord))
    const parsedPage = parseInt(page) + 1 // page is 0-indexed in AI metadata
    const { x, y, width, height } = convertToPDFTronParams(
      coords,
      this.documentViewer.getPageWidth(parsedPage),
      this.documentViewer.getPageHeight(parsedPage),
      this.instance.Core.PageRotation[
        this.documentViewer.getCompleteRotation(parsedPage)
      ]
    )
    const annotation = new this.instance.Core.Annotations.RectangleAnnotation()

    annotation.PageNumber = parsedPage
    annotation.X = x
    annotation.Y = y
    annotation.Width = width
    annotation.Height = height
    annotation.StrokeColor = new this.instance.Core.Annotations.Color(
      ...ANNOTATION_BORDER_COLOR_RGB
    )
    annotation.FillColor = new this.instance.Core.Annotations.Color(
      ...ANNOTATION_FILL_COLOR_RGB
    )

    return annotation
  }

  drawAnnotations(annotations) {
    this.documentViewer.clearSelection()
    this.annotationManager.disableRedaction()
    this.annotationManager.enableReadOnlyMode()
    this.annotationManager.addAnnotations(annotations)

    return this.annotationManager.drawAnnotationsFromList(annotations)
  }

  highlightAnnotation(annotation) {
    annotation.StrokeColor = new this.instance.Core.Annotations.Color(
      ...ANNOTATION_SELECTED_BORDER_COLOR_RGB
    )
    annotation.FillColor = new this.instance.Core.Annotations.Color(
      ...ANNOTATION_SELECTED_FILL_COLOR_RGB
    )
    this.annotationManager.redrawAnnotation(annotation)
  }

  lowlightAnnotation(annotation) {
    annotation.StrokeColor = new this.instance.Core.Annotations.Color(
      ...ANNOTATION_BORDER_COLOR_RGB
    )
    annotation.FillColor = new this.instance.Core.Annotations.Color(
      ...ANNOTATION_FILL_COLOR_RGB
    )
    this.annotationManager.redrawAnnotation(annotation)
  }

  jumpToAnnotation(annotation) {
    this.annotationManager.jumpToAnnotation(annotation, {
      isSmoothScroll: true,
    })
  }

  deleteAnnotations() {
    this.annotationManager.deleteAnnotations(Object.values(this.annotations))
    this.annotations = {}
  }

  enableRedaction() {
    this.annotationManager.enableRedaction()
    this.annotationManager.disableReadOnlyMode()
  }
}
